import React from 'react'
import { required, SelectInputProps } from 'react-admin'
import { COMMON_FIELDS } from '../../../providers/localization/constant'
import { DepSelectInput } from '../../inputs/DepSelectInput'

const defaultProps = {
  label: `${COMMON_FIELDS}.published_to.label`,
  source: 'publish_condition',
  choices: [
    { id: 'a', name: `${COMMON_FIELDS}.published_to.choices.all_project` },
    { id: 's', name: `${COMMON_FIELDS}.published_to.choices.specific_project` },
  ],
}

export const NewsPublishCondSelectInput: React.FC<SelectInputProps> = ({
  label,
  source,
  choices,
  disabled = false,
  ...props
}) => {
  return (
    <DepSelectInput
      depField='type'
      expectedValue='p'
      margin='none'
      disabled={disabled}
      fullWidth
      label={label}
      source={source}
      choices={choices}
      validate={[required()]}
      translateChoice={true}
      {...props}
    />
  )
}

NewsPublishCondSelectInput.defaultProps = defaultProps
